import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requiredRole = null, requiredRoles = null }) => {
  const { isAuthenticated, isAdmin, isMedico, isPaziente, isMerchant, getRoles, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const roles = requiredRoles || (requiredRole ? [requiredRole] : []);
  const hasRole = () => {
    if (roles.length === 0) return true;
    const userRoles = getRoles();
    return roles.some((r) => {
      if (r === 'ADMIN') return isAdmin();
      if (r === 'MEDICO') return isMedico();
      if (r === 'PAZIENTE') return isPaziente();
      if (r === 'MERCHANT') return isMerchant();
      if (r === 'STRUTTURA_ADMIN') return userRoles.includes('STRUTTURA_ADMIN');
      return userRoles.includes(r);
    });
  };

  if (roles.length > 0 && !hasRole()) {
    // Multi-ruolo: torna alla scelta area invece di un muro con solo "logout"
    if (getRoles().length > 1) {
      return <Navigate to="/app/scegli-area" replace />;
    }
    return <Navigate to="/access-denied" replace />;
  }

  return children;
};

export default ProtectedRoute;

